import { Component, Inject, } from '@angular/core';
import { SalesDocument } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';
import { OfferValidityService } from '../offer-validity/offer-validity.service';
import { PositionService } from '../position.service';
import { PriceVersionService } from '../price-version-selector/price-version.service';
@Component({
    selector: 'icc-send-valuation-dialog',
    templateUrl: './send-valuation-dialog.component.html',
    styleUrls: ['./send-valuation-dialog.component.scss'],
})
export class SendValuationDialogComponent {

    validityDate: Date = new Date();

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            hasNonValuatedPositions: boolean;
        },
        private translateService: TranslateService,
        private dialogRef: DialogRef,
        private positionService: PositionService,
        private priceVersionService: PriceVersionService,
        private offerValidityService: OfferValidityService,
    ) {
        const priceCalculationDate = new Date();
        const currentOfferValidity = this.offerValidityService.getCurrentOfferValidity(
            data.document
        );
        const documentPriceVersion = this.priceVersionService.getPriceVersion(
            data.document.priceVersionId
        );
        this.validityDate = this.positionService.getPositionValidity(
            priceCalculationDate,
            data.document.isConfirmed,
            documentPriceVersion,
            currentOfferValidity
        );
    }

    close() {
        this.dialogRef.close();
    }

    send() {
        this.dialogRef.close({
            validityDate: this.validityDate,
        });
    }
}
